import Create from './Create'
import Edit from './Edit'
import Scorm from './View'

export default {
  Create,
  Edit,
  Scorm
}
